/* Falcon paid-click attribution capture.
   Captures the Google click id (gclid / gbraid / wbraid) on landing and
   persists it onto the cart, so it lands in the order note_attributes
   server-side. This survives the Shopify Markets locale redirect and
   Safari ITP, which strip the click id from the landing URL (only ~25%
   of orders kept it). The cart attribute becomes the source of truth,
   read later for offline conversion upload to Google Ads (Phase 3).
   Customer-invisible; it only adds hidden order attributes. */
(function () {
  var STORE_KEY = 'falcon_attr_v1';

  function getParam(name) {
    var m = new RegExp('[?&]' + name + '=([^&]+)').exec(window.location.search);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function getGclCookie() {
    /* Google sets _gcl_aw = "GCL.<timestamp>.<gclid>" on an ad click via the
       gtag the Shopify Google channel installs. The cookie survives the
       Markets locale redirect that drops the URL param, so it is the more
       reliable source. */
    var m = document.cookie.match(/_gcl_aw=GCL\.\d+\.([^;]+)/);
    return m ? m[1] : null;
  }
  function readStored() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}'); }
    catch (e) { return {}; }
  }
  function store(d) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(d)); } catch (e) {}
  }

  var stored = readStored();
  var clickId = getParam('gclid') || getParam('gbraid') || getParam('wbraid') || getGclCookie();

  /* Capture once per visit; first touch wins. */
  if (clickId && !stored.gclid) {
    stored.gclid = clickId;
    stored.utm_source = getParam('utm_source') || stored.utm_source || '';
    stored.utm_medium = getParam('utm_medium') || stored.utm_medium || '';
    stored.utm_term = getParam('utm_term') || stored.utm_term || '';
    stored.utm_campaign = getParam('utm_campaign') || stored.utm_campaign || '';
    stored.captured_at = new Date().toISOString();
    stored.landing = window.location.pathname;
    store(stored);
  }

  /* Persist onto the cart so it reaches order.note_attributes. Only when we
     have a click id, and only once per click id, so organic visitors are
     never touched and we do not spam /cart/update.js. */
  if (stored.gclid && stored.written_gclid !== stored.gclid) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'gclid': stored.gclid,
          'attribution-source': stored.utm_source || '',
          'attribution-medium': stored.utm_medium || '',
          'attribution-term': stored.utm_term || '',
          'attribution-campaign': stored.utm_campaign || '',
          'attribution-captured-at': stored.captured_at || ''
        }
      })
    }).then(function () {
      stored.written_gclid = stored.gclid;
      store(stored);
    }).catch(function () { /* non-blocking */ });
  }
})();
